document.addEventListener("DOMContentLoaded", function(){
  window.addEventListener("scroll", function(){
    var scrollAnimated = document.querySelectorAll(".fade-up, .fade-down, .fade-right")
    Array.from(scrollAnimated).forEach(el => {
      const rect = el.getBoundingClientRect()
      if(rect.top < window.innerHeight && rect.bottom >= 0){
        el.classList.add("scroll")
      }else{
        el.classList.remove("scroll")
      }
    })
  })
})